import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import Content from "../Modulos/AtendimentoAmb/Home/Content";
import ModalNovoAtendimento from "../Modulos/AtendimentoAmb/Home/ModalNovoAtendimento";
import ModalGerenciarQueixas from "../Modulos/AtendimentoAmb/Home/ModalGerenciarQueixas";
import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useModal } from "../contexts/ModalContext";
import { AuthContext } from "../Auth/AuthProvider";
import { VerifyPermission } from "../Funcoes/VerifyPermission";

const PERMISSAO_BASE = { modulo: "ssma", submodulo: "atendimento-amb" };

const AtendimentoAmb = () => {

    const { openModal, closeModal, isModalOpen } = useModal();
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const [listRefreshKey, setListRefreshKey] = useState(0);

    const podeLancarEditar = useMemo(
        () => VerifyPermission(user, { ...PERMISSAO_BASE, funcao: "lancar-editar" }),
        [user]
    );

    const podeGerenciarQueixas = useMemo(
        () => VerifyPermission(user, { ...PERMISSAO_BASE, funcao: "gerenciar-queixas" }),
        [user]
    );

    const podeAcessarAtestados = useMemo(
        () => VerifyPermission(user, { ...PERMISSAO_BASE, funcao: "atestados-access" }),
        [user]
    );

    const podeAcessarTestes = useMemo(
        () => VerifyPermission(user, { ...PERMISSAO_BASE, funcao: "testes-alcool-drogas-access" }),
        [user]
    );

    const openSidebar = () => openModal("atendimentoAmbSidebar");

    const openNovoAtendimento = () => {
        if (!podeLancarEditar) return;
        closeModal();
        openModal("atendimentoAmbNovo");
    };

    const openGerenciarQueixas = () => {
        if (!podeGerenciarQueixas) return;
        closeModal();
        openModal("atendimentoAmbQueixas");
    };

    const openAtestados = () => {
        if (!podeAcessarAtestados) return;
        closeModal();
        navigate("/modulo/ssma/atendimento-amb/atestados");
    };

    const openTestesAlcoolDrogas = () => {
        if (!podeAcessarTestes) return;
        closeModal();
        navigate("/modulo/ssma/atendimento-amb/testes-alcool-drogas");
    };

    return (
        <>
            <NavBar
                title="ATENDIMENTO AMBULATORIAL"
                goBackOnePage
                setSideBar={openSidebar}
            />
            <GenericBody>
                <Content refreshKey={listRefreshKey} />
            </GenericBody>

            {isModalOpen("atendimentoAmbSidebar") && (
                <Overlay state changeContent={closeModal}>
                    <SideMenu>
                        {podeLancarEditar && (
                            <SideMenuBtn button="NOVO ATENDIMENTO" clickFunc={openNovoAtendimento} />
                        )}
                        {podeGerenciarQueixas && (
                            <SideMenuBtn button="GERENCIAR QUEIXAS" clickFunc={openGerenciarQueixas} />
                        )}
                        {podeAcessarAtestados && (
                            <SideMenuBtn button="ATESTADOS" clickFunc={openAtestados} />
                        )}
                        {podeAcessarTestes && (
                            <SideMenuBtn button="TESTES ALCOOL E DROGAS" clickFunc={openTestesAlcoolDrogas} />
                        )}
                    </SideMenu>
                </Overlay>
            )}

            {podeGerenciarQueixas && isModalOpen("atendimentoAmbQueixas") && (
                <ModalGerenciarQueixas />
            )}

            {podeLancarEditar && isModalOpen("atendimentoAmbNovo") && (
                <ModalNovoAtendimento onSaved={() => setListRefreshKey((k) => k + 1)} />
            )}
        </>
    );
};

export default AtendimentoAmb;
